import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Billing
function pathBillingDetails() {
  return `billing-details`;
}

export function patchBillingDetails(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathBillingDetails(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postCreateStripeCheckoutSession(successCallback, errorCallback) {
  postAuth({
    "path": `billing-details/create-stripe-checkout-session`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}

// Credits
export function getViewManageCredits(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-credits`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Invoice
export function getViewInvoices(successCallback, errorCallback, invoiceId) {
  getAuth({
    "path": `view/invoices/${invoiceId}`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageInvoices(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-invoices`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageInvoiceItems(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-invoice-items`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Subscription
function pathSubscriptions(subscriptionId=null) {
  if (subscriptionId) {
      return `subscriptions/${subscriptionId}`;
  } else {
      return `subscriptions`;
  }
}

export function createSubscriptions(successCallback, errorCallback, data) {
  postAuth({
    "path": pathSubscriptions(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchSubscriptions(successCallback, errorCallback, data, subscriptionId) {
  patchAuth({
    "path": pathSubscriptions(subscriptionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewManageSubscriptions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-subscriptions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewSubscriptionShforms(subscriptionId=null) {
  if (subscriptionId) {
      return `view/subscription-shforms/${subscriptionId}`;
  } else {
      return `view/subscription-shforms`;
  }
}

export function getViewSubscriptionShforms(successCallback, errorCallback, subscriptionId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewSubscriptionShforms(subscriptionId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}















